import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import { gatewayRequestAxios } from '../../api/interceptor'
import { GATEWAY_API_LOGIN_HISTORY } from '../../util/config'

const historyState = {
  total: 0,
  history: []
}

const initialState = {
  loginHistoryObj: { ...historyState },
  status: 'idle',
  error: null
}

export const fetchLoginHistory = createAsyncThunk(
  'loginHistory/fetch',
  async ({ rejectWithValue } = {}, { pageSize = 20, pageOffset = 0 } = {}) => {
    try {
      const response = await gatewayRequestAxios.get(GATEWAY_API_LOGIN_HISTORY, {
        params: { pageSize, pageOffset }
      })

      const data = response.data || {}
      const fullHistory = Array.isArray(data.history) ? data.history : []

      // enforce current ticket scope: page 0, size 20
      const cappedHistory = fullHistory.slice(0, pageSize)

      return {
        ...data,
        history: cappedHistory
      }
    } catch (err) {
      if (rejectWithValue) {
        return rejectWithValue(err?.response?.data?.message || err.message || 'Failed to fetch login history')
      }
      throw err
    }
  },
  {
    condition: (_, { getState }) => {
      const { loginHistory } = getState()
      return loginHistory.status !== 'loading' && loginHistory.status !== 'succeeded'
    }
  }
)

export const loginHistorySlice = createSlice({
  name: 'login-history',
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(fetchLoginHistory.pending, (state) => {
        state.status = 'loading'
        state.loginHistoryObj = { ...historyState }
        state.error = undefined
      })
      .addCase(fetchLoginHistory.fulfilled, (state, action) => {
        state.status = 'succeeded'
        state.error = undefined
        state.loginHistoryObj = action.payload ?? { ...historyState }
      })
      .addCase(fetchLoginHistory.rejected, (state, action) => {
        state.status = 'failed'
        state.loginHistoryObj = { ...historyState }
        state.error = action.error.message
      })
  }
})

export default loginHistorySlice.reducer

export const selectLoginHistoryObject = (state) => state.loginHistory.loginHistoryObj
export const getLoginHistoryStatus = (state) => state.loginHistory.status
export const getLoginHistoryError = (state) => state.loginHistory.error
